module.exports = __webpack_public_path__ + "static/media/Illus-Flower.bbbf045b.png";